import {HTTP} from "../_helpers/http";

export default class SupplierOrderAPI {
    static getOrders(supplierId, filter) {
        return HTTP.get('/supplier/'+ supplierId + '/order', {
            params: filter
        }).then(response => response.data);
    }
    static getSupplierList() {
        return HTTP.get('/supplier/').then(response => response.data);
    }
}